export const VALIDATION_STATUS = {
    required: 'required',
    valid: 'valid',
    incomplete: 'incomplete',
};
export const VALIDATION_PATTERN = {
    uppercase: /^[A-Z]/,
    lowercase: /[a-z]/,
    alphanumeric: /^[a-zA-Z0-9]*$/,
    number: /^[0-9]*$/,
    currencyAmount: /^([0-9]*[.,][0-9]{1,2}|[0-9]*)$/,
    decimalNumber: /^[0-9]+(\.[0-9]+)?$/,
    numberNotZero: /^[1-9]\d*$/,
    positiveInteger: /^((\+)?[1-9]\d*)?$/,
    noNumber: /^([^0-9]*)$/,
    noUppercase: /^([^A-Z]*)$/,
    noLowercase: /^([^a-z]*)$/,
    ascii: /^[\x00-\x7f]+$/,
    email: /^((([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,6})?$/,
    emailAddress: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    username: /^([^\\s]+)$/,
    passwordSpecialChars: /^[$@!%*?&()~;:_+=.]/,
    passwordAllowedChars: /^([a-zA-Z0-9!=+_$:;^/()~?.¬%*]*)$/,
    weakPassword: /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])[a-zA-Z0-9!=+_$:;^\/()~?.¬%*]{8,}$/,
    mediumPassword: /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[$&+,:;=?@#|\'<>.^*()%!-])[a-zA-Z0-9!=+_$:;^\/()~?.¬%*]{8,}$/,
    strongPassword: /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[$&+,:;=?@#|\'<>.^*()%!-])[a-zA-Z0-9!=+_$:;^\/()~?.¬%*]{10,}$/,
    percentageNoDecimal: /^(\d{0,2}|100)$/,
};
export const ITALY_COMPANY_VALIDATION_PATTERN = {
    userCodiceFiscale: /^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$/,
    companyCodiceFiscale: /^(([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})|([0-9]{11}))$/,
};
